import React from 'react';
import clsx from 'clsx';
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    // height: 60, 
    background: '#f5f5f5', 
    boxShadow: theme.shadows[0]
  }
}));

function CardTitle(props) {
  const classes = useStyles()
  const { children, className, ...other } = props;

  return (
    <CardHeader className={clsx(classes.root, className)} {...other} />
  );
}

export default CardTitle